/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import EventsControllerDtoDrawItemDetailDrawItemRewardDetailData from './EventsControllerDtoDrawItemDetailDrawItemRewardDetailData';
import EventsControllerDtoDrawItemDetailImageData from './EventsControllerDtoDrawItemDetailImageData';
import MaterialProperty from './MaterialProperty';

/**
 * The EventsControllerDtoDrawItemDetailResponse model module.
 * @module model/EventsControllerDtoDrawItemDetailResponse
 * @version 1.0
 */
class EventsControllerDtoDrawItemDetailResponse {
    /**
     * Constructs a new <code>EventsControllerDtoDrawItemDetailResponse</code>.
     * @alias module:model/EventsControllerDtoDrawItemDetailResponse
     */
    constructor() { 
        
        EventsControllerDtoDrawItemDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoDrawItemDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoDrawItemDetailResponse} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoDrawItemDetailResponse} The populated <code>EventsControllerDtoDrawItemDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoDrawItemDetailResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('perPrice')) {
                obj['perPrice'] = ApiClient.convertToType(data['perPrice'], 'Number');
            }
            if (data.hasOwnProperty('xperPrice')) {
                obj['xperPrice'] = ApiClient.convertToType(data['xperPrice'], 'Number');
            }
            if (data.hasOwnProperty('purchaseLimit')) {
                obj['purchaseLimit'] = ApiClient.convertToType(data['purchaseLimit'], 'Number');
            }
            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemCount')) {
                obj['itemCount'] = ApiClient.convertToType(data['itemCount'], 'Number');
            }
            if (data.hasOwnProperty('descImage')) {
                obj['descImage'] = ApiClient.convertToType(data['descImage'], 'String');
            }
            if (data.hasOwnProperty('region')) {
                obj['region'] = ApiClient.convertToType(data['region'], 'String');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('reward')) {
                obj['reward'] = ApiClient.convertToType(data['reward'], [EventsControllerDtoDrawItemDetailDrawItemRewardDetailData]);
            }
            if (data.hasOwnProperty('imageUrls')) {
                obj['imageUrls'] = ApiClient.convertToType(data['imageUrls'], [EventsControllerDtoDrawItemDetailImageData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoDrawItemDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoDrawItemDetailResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['descImage'] && !(typeof data['descImage'] === 'string' || data['descImage'] instanceof String)) {
            throw new Error("Expected the field `descImage` to be a primitive type in the JSON string but got " + data['descImage']);
        }
        // ensure the json data is a string
        if (data['region'] && !(typeof data['region'] === 'string' || data['region'] instanceof String)) {
            throw new Error("Expected the field `region` to be a primitive type in the JSON string but got " + data['region']);
        }
        if (data['reward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['reward'])) {
                throw new Error("Expected the field `reward` to be an array in the JSON data but got " + data['reward']);
            }
            // validate the optional field `reward` (array)
            for (const item of data['reward']) {
                EventsControllerDtoDrawItemDetailDrawItemRewardDetailData.validateJSON(item);
            };
        }
        if (data['imageUrls']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['imageUrls'])) {
                throw new Error("Expected the field `imageUrls` to be an array in the JSON data but got " + data['imageUrls']);
            }
            // validate the optional field `imageUrls` (array)
            for (const item of data['imageUrls']) {
                EventsControllerDtoDrawItemDetailImageData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
EventsControllerDtoDrawItemDetailResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
EventsControllerDtoDrawItemDetailResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
EventsControllerDtoDrawItemDetailResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
EventsControllerDtoDrawItemDetailResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
EventsControllerDtoDrawItemDetailResponse.prototype['contentsReward'] = undefined;

/**
 * @member {String} title
 */
EventsControllerDtoDrawItemDetailResponse.prototype['title'] = undefined;

/**
 * @member {Number} perPrice
 */
EventsControllerDtoDrawItemDetailResponse.prototype['perPrice'] = undefined;

/**
 * @member {Number} xperPrice
 */
EventsControllerDtoDrawItemDetailResponse.prototype['xperPrice'] = undefined;

/**
 * @member {Number} purchaseLimit
 */
EventsControllerDtoDrawItemDetailResponse.prototype['purchaseLimit'] = undefined;

/**
 * @member {Number} itemId
 */
EventsControllerDtoDrawItemDetailResponse.prototype['itemId'] = undefined;

/**
 * @member {Number} itemCount
 */
EventsControllerDtoDrawItemDetailResponse.prototype['itemCount'] = undefined;

/**
 * @member {String} descImage
 */
EventsControllerDtoDrawItemDetailResponse.prototype['descImage'] = undefined;

/**
 * @member {String} region
 */
EventsControllerDtoDrawItemDetailResponse.prototype['region'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoDrawItemDetailResponse.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoDrawItemDetailResponse.prototype['endAt'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoDrawItemDetailResponse.prototype['createdAt'] = undefined;

/**
 * @member {Array.<module:model/EventsControllerDtoDrawItemDetailDrawItemRewardDetailData>} reward
 */
EventsControllerDtoDrawItemDetailResponse.prototype['reward'] = undefined;

/**
 * @member {Array.<module:model/EventsControllerDtoDrawItemDetailImageData>} imageUrls
 */
EventsControllerDtoDrawItemDetailResponse.prototype['imageUrls'] = undefined;






export default EventsControllerDtoDrawItemDetailResponse;

